import { styled } from 'baseui'
import { FlexCenterY } from '@/shared/theme/styled-components'

export const StyledContainer = styled('div', () => ({
  width: '100%',
  padding: '0rem',
}))

export const TimelineContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  padding: '0 1rem 1rem 2.5rem',
})

export const TimelineLine = styled('div', ({ $theme, $last, $height }) => ({
  position: 'absolute',
  left: '1.53rem',
  width: '0.225rem',
  backgroundColor: $theme.colors.mono400,
  top: '1.65rem',
  height: $height || 'auto',
  bottom: $last ? '0' : '3rem',
}))

export const TimelineDateGroup = styled('div', ({ $theme }) => ({
  position: 'relative',
  padding: '1rem 0 0.5rem 0',
  '::before': {
    content: '""',
    position: 'absolute',
    left: '-1.5rem',
    top: '1.25rem',
    width: '1.25rem',
    height: '1.25rem',
    borderRadius: '50%',
    backgroundColor: $theme.colors.white,
    border: `0.125rem solid ${$theme.colors.barInactive}`,
  },
  '::after': {
    content: '""',
    position: 'absolute',
    left: '-1.125rem',
    top: '1.625rem',
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '50%',
    backgroundColor: $theme.colors.barInactive,
  },
}))

export const TimelineDate = styled('div', ({ $theme }) => ({
  position: 'relative',
  fontSize: '0.875rem',
  color: $theme.colors.textHeading,
  marginTop: '0.25rem',
  paddingLeft: '0.5rem',
}))

export const ContractsList = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const ContractItem = styled(FlexCenterY, {
  padding: '0.1rem 0.1rem',
  cursor: 'pointer',
})

export const ContractType = styled(FlexCenterY, ({ $theme }) => ({
  color: $theme.colors.grey,
  fontSize: '0.9375rem',
}))

export const ContractPrestationType = styled('span', ({ $theme }) => ({
  fontSize: '0.75rem',
  color: $theme.colors.textLabel,
  marginLeft: 'auto',
  padding: '0.1875rem 0.5rem',
  backgroundColor: $theme.colors.borderMuted,
  borderRadius: '0.75rem',
  fontWeight: 500,
  alignSelf: 'center',
}))

export const IconWrapper = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: '1',
  marginRight: '0.1rem',
})

export const StyledEmptyMessageContainer = styled(FlexCenterY, {
  padding: '0rem 0.5rem 1rem 1rem',
})

export const StyledEmptyIcon = styled('img', () => ({
  width: 'auto',
}))

export const StyledEmptyText = styled('span', ({ $theme }) => ({
  paddingTop: '0.45rem',
  color: $theme.colors.grey,
}))
